module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABRElEQVRYhe2XsUoDQRCGvwlWYmUhYqmdiIhgayPEd7CytrOxtbCwkmDrU+gTWIpYa2EhItoIioVFCCGfhYnGYKLs5e4U/eFg2bmZ+ZjZY+eCDFKXgX1gEhgBKu0HoNX1amfdBA6A7YjIkhrUUfXBNK114lQGJflC08B4ou/SMAAugdsM/sBr35IUEQ11FdhjcCVGgbnUPJmlLnxyBmode5YWDEX/AEUAtAYZ/0QFmmUD1MsGuAGue/bOCsj7LnVePVbP1S210Py/SOq6eqIeqcVeIGq158K4U8fyztv9Faz02KaA2SIBSlGlz3rQXm4AKfbcAXLXj29B7iq9Al+N5TX1sY+tBdwDuxFxMQyAz0anxW/EqKozEfGcAtBd4kZKAGACmE/0/QBwmhijDlylArz9I7eHhB1gg+8fvidgMyIOUwFeAMkvtrR5nEESAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/form/icon_resize.png
// module id = 1907
// module chunks = 50